import React from 'react'
import _Select, { components } from 'react-select'
import ASelect from 'react-select/async'
import CSelect from 'react-select/creatable'
import Label from './Input/Label'
import { parseOptions } from './Picklist'
import getStyles from './Select/styles.js'
import FieldError from './FieldError'
export class Input extends React.Component {
  onChange = (v, a) => {
    const { config: { maxSelected } = {} } = this.props
    let _v = null
    if (v) {
      const lastAdded = v[v.length - 1]
      v.pop()
      const lastAddedArray = lastAdded.value.split(',').map(entry => ({ label: entry, value: entry }))
      _v = [...v, ...lastAddedArray]
      if((maxSelected &&_v.length > maxSelected)) {
        _v = _v.splice(0, maxSelected)
      }
    }
    let { onChange, onValueChange } = this.props
    onChange && onChange(_v, a)
    let value = _v && _v.map(v => v.value).join(';')
    onValueChange && onValueChange(value)
  }

  onKeyDown = (e) => {
    if (e.keyCode === 13 && this.select && this.select.select && this.select.select.menuListRef) {
      e.stopPropagation()
    }
  }

  getRef = ref => this.select = ref

  render () {
    let props = this.props
    const { config: { disableInput, maxSelected, maxSelectedText } = {} } = props
    let value = props.data || props.value
    if (typeof value === 'string') value = value.split(';')
    let options = parseOptions(props.picklist || props.options || [])
    let Select = props.isCreatable ? CSelect : props.isAsync ? ASelect : _Select
    const selValue = value && options.filter(o => value.includes(o.value))
    const hasValue = selValue && selValue.length
    return (
      <div className={`w-100 input-wrapper`}>
        <Label {...props} />
        <Select
          ref={this.getRef}
          onKeyDown={this.onKeyDown}
          {...props}
          isSearchable={!disableInput}
          isMulti
          value={props.uncontrolled ? undefined : (selValue || null)}
          defaultValue={props.uncontrolled ? selValue : undefined}
          className={`input ${(props.required && !hasValue && `is-invalid`) || ''}`}
          options={options}
          onChange={this.onChange}
          isClearable
          hasValue={!!selValue}
          menuPortalTarget={document.body}
          components={{
            ...!props.icon && { DropdownIndicator: () => null },
            IndicatorSeparator: () => null,
            Menu: menuProps => <Menu maxSelected={maxSelected} maxSelectedText={maxSelectedText} {...menuProps} />,
            MenuList: (props) => {
              let children = props.children
              if (children && Array.isArray(children)) children = children.slice(0, props.maxOptions || 25)
              return <components.MenuList {...props} children={children} />
            }
          }}
          placeholder={props.placeholder}
          styles={getStyles(props)}
          classNamePrefix={`react-multi-select`}
          isDisabled={props.disabled}
          openMenuOnClick={!props.hideMenuOnClick}
          menuPlacement={`auto`}
          closeMenuOnSelect={false}
          defaultMenuIsOpen={props.autoFocus || false}
        />
        <style jsx>{`
          :global(.react-multi-select__multi-value__remove) {
            cursor: pointer;
          }
          :global(.react-multi-select__multi-value__label) {
            padding: 1px 3px;
          }
          :global(.react-multi-select__value-container div:last-child) {
            padding-top: 0;
            padding-bottom: 0;
            margin: 0 2px;
          }
          `}</style>
          <FieldError error={props.error} />
      </div>
    )
  }
}

const Menu = props => {
  const optionSelectedLength = props.getValue().length || 0;
  return (
    <components.Menu {...props}>
      {(!props.maxSelected || optionSelectedLength < props.maxSelected) ? (
        props.children
      ) : (
        <div style={{ margin: 15 }}>{props.maxSelectedText || 'Max no. of items reached.'}</div>
      )}
    </components.Menu>
  )
}

export const Output = props => {
  const data = props.data || props.value
  return (
    <div className='multiselect-tags'>
      {Array.isArray(data) && data.map(item => <span key={`${Math.random(0, 1000)}-${item}`} data-toggle={`tooltip`} data-placement={`top`} title={item}>{item}</span>)}
      {typeof data === 'string' &&data.length && data.split(';').map((item, index) => <span key={`tag-${index}`} data-toggle={`tooltip`} data-placement={`top`} title={item}>{item}</span>)}
      <style jsx>{`
      .multiselect-tags {
        display: flex;
        align-items: center;
        width: 100%;
      }
      .multiselect-tags > span {
        display: inline-block;
        position: relative;
        border: none;
        border-radius: 3px;
        box-shadow: none;
        background-color: #5c7080;
        min-width: 55px;
        padding: 2px 6px;
        line-height: 16px;
        color: #f5f8fa;
        font-size: 12px;
        margin-right: .25em;
        white-space: nowrap;
        overflow: hidden;
        cursor: default;
      }
      `}</style>
    </div>
  )
}
